'use client';

import React from 'react';
import { useTranslations } from 'next-intl';
import { motion } from 'framer-motion';
import { fadeInUp, scaleIn, staggerContainer, viewportOnce } from '@/lib/animations';
import Image from 'next/image';

export default function EMPSA() {
  const t = useTranslations('EMPSA');

  return (
    <section id="empsa" className="w-full py-16 sm:py-24 px-6 sm:px-10 lg:px-16">
      <div className="max-w-8xl mx-auto space-y-10">
        <motion.div
          className="space-y-4 max-w-7xl"
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={staggerContainer(0.1)}
        >
          <motion.span variants={fadeInUp} className="text-[10px] sm:text-xs font-bold tracking-widest text-red-600 uppercase block">
            {t('badge')}
          </motion.span>

          <motion.h2 variants={fadeInUp} id="empsa-heading" className="text-3xl sm:text-4xl lg:text-5xl font-black text-gray-900 tracking-tight leading-tight">
            {t('heading')}
          </motion.h2>

          <motion.div variants={fadeInUp} className="space-y-3 pt-2 text-xs sm:text-sm text-gray-500 font-normal leading-relaxed">
            <p>
              {t.rich('paragraph_1', {
                bold: (chunks) => <strong className="font-bold text-gray-800">{chunks}</strong>,
              })}
            </p>
            <p>
              {t.rich('paragraph_2', {
                bold: (chunks) => <strong className="font-bold text-gray-800">{chunks}</strong>,
              })}
            </p>
          </motion.div>
        </motion.div>

        <motion.div
          className="bg-white border border-gray-100 rounded-3xl p-6 sm:p-10 shadow-sm flex flex-col md:flex-row items-start gap-6 relative overflow-hidden"
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          variants={scaleIn}
        >
          
          <div className="flex items-center justify-center">
            <span className="text-white font-black text-xs tracking-wider">
              <Image src='/images/empsa.png' alt='EMPSA logo' width='80' height='80' />
            </span>
          </div>

          <div className="space-y-3 flex-1">
            <h3 className="text-lg sm:text-xl font-extrabold text-gray-900 tracking-tight">
              {t('card_title')}
            </h3>

            <p className="text-xs sm:text-sm font-bold text-gray-900">
              {t('card_subtitle')}
            </p>

            <p className="text-xs sm:text-sm text-gray-500 font-normal leading-relaxed pt-1">
              {t('card_description')}
            </p>

          {/*/Removed temporarely, no link where to redirect  /*}
            {/* <div className="pt-3">
              <a
                href="#european-credentials"
                className="inline-flex items-center gap-2 text-xs sm:text-sm font-bold text-red-600 hover:text-red-700 transition-colors group"
              >
                <span>{t('cta_link')}</span>
                <svg
                  className="w-4 h-4 transition-transform group-hover:translate-x-1"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                </svg>
              </a>
            </div> */}
          </div>

        </motion.div>

      </div>
    </section>
  );
}